var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeOrderInTransit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 215,
    height: 48,
    viewBox: "0 0 215 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.09766 32.4367C2.09766 32.4367 10.4281 31.3611 19.8994 33.9451C37.9131 38.8596 38.9407 29.8599 45.6204 25.5204C51.7316 21.5503 56.7928 23.9726 63.5971 28.8278C68.6156 32.4087 75.9294 38.4196 83.5037 37.4519C90.4273 36.5673 95.3356 29.5174 104.933 27.7245C112.539 26.3035 118.72 30.2073 127.479 28.8278C139.36 26.9563 144.668 15.9388 153.159 15.9388C163.64 15.9388 171.019 6.62061 180.554 6.62061C190.032 6.62061 191.319 12.0999 201.687 15.9388C209.614 18.8737 213.428 15.9388 213.428 15.9388V47.3879H2.09766V32.4367Z",
    fill: "url(#paint0_linear_8655_9946)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.09766 27.552C2.09766 27.552 10.4281 26.492 19.8994 29.0385C37.9131 33.8819 38.9407 25.0125 45.6204 20.7359C51.7316 16.8232 56.7928 19.2104 63.5971 23.9953C68.6156 27.5244 75.9294 33.4483 83.5037 32.4946C90.4273 31.6229 95.3356 24.6749 104.933 22.908C112.539 21.5075 118.72 25.3549 127.479 23.9953C139.36 22.151 144.668 11.2929 153.159 11.2929C163.64 11.2929 171.019 2.0874 180.554 2.0874C190.032 2.0874 190.536 7.50962 200.904 11.2929C208.831 14.1853 213.428 11.2929 213.428 11.2929",
    stroke: "#1BB9F8",
    strokeWidth: 2.71268,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8655_9946",
    x1: 40.2904,
    y1: 27.3061,
    x2: 40.2904,
    y2: 47.3879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BB9F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeOrderInTransit);
export default __webpack_public_path__ + "static/media/home-order-inTransit.f78cd334b620bbd4615731c55a554519.svg";
export { ForwardRef as ReactComponent };